import ReducerUtils from "../../../utils/ReducerUtils"
import Actions      from "../../../model/constant/actions"


const retrievingAdGroupConfigs = ReducerUtils.createReducer(false,{
  [Actions.RETRIEVING_AD_GROUP_CONFIG] : (state,action)=>action.status,
})

export default retrievingAdGroupConfigs
